import { createSlice } from '@reduxjs/toolkit';
import {
  _setActualAPRD,
  _setArea,
  _setCCCMS,
  _setCDCNumber,
  _setEpisodeComment,
  _setEpisodeDischargeDate,
  _setEpisodeDischargeReason,
  _setEpisodeSAPStartDate,
  _setEprd,
  _setInactivity,
  _setIncarcerationInstitution,
  _setLastCountyofResidence,
  _setParoleAgent,
  _setParoleCounty,
  _setReferralSource,
  _setTIR,
} from './NewEpisodeActions';
import initialState from './NewEpisodeInitialState';

export const newEpisodeSlice = createSlice({
  name: 'stop/episode',
  initialState,
  reducers: {
    newEpisode: (state, action) => {
      state.newEpisode = action.payload;
    },
    setEpisodeSAPStartDate: _setEpisodeSAPStartDate,
    setEprd: _setEprd,
    setActualAPRD: _setActualAPRD,
    setCDCNumber: _setCDCNumber,
    setEpisodeComment: _setEpisodeComment,
    setEpisodeDischargeDate: _setEpisodeDischargeDate,
    setTIR: _setTIR,
    setCCCMS: _setCCCMS,
    setInactivity: _setInactivity,
    setIncarcerationInstitution: _setIncarcerationInstitution,
    setReferralSource: _setReferralSource,
    setLastCountyofResidence: _setLastCountyofResidence,
    setParoleCounty: _setParoleCounty,
    setParoleAgent: _setParoleAgent,
    setArea: _setArea,
    setEpisodeDischargeReason: _setEpisodeDischargeReason,
    resetEpisode: () => initialState,
  },
});

export const {
  newEpisode,
  setEpisodeSAPStartDate,
  setEprd,
  setActualAPRD,
  setCDCNumber,
  setEpisodeComment,
  setEpisodeDischargeDate,
  setTIR,
  setCCCMS,
  setInactivity,
  setIncarcerationInstitution,
  setReferralSource,
  setLastCountyofResidence,
  setParoleCounty,
  setParoleAgent,
  setArea,
  setEpisodeDischargeReason,
  resetEpisode,
} = newEpisodeSlice.actions;

export default newEpisodeSlice.reducer;
